import * as THREE from "three";

function offsetPath(points, offsetDistance) {
	return points.map((point, i, arr) => {
		let dx, dy;

		// Compute tangent vector
		if (i === 0) {
			dx = arr[i + 1].x - point.x;
			dy = arr[i + 1].y - point.y;
		} else if (i === arr.length - 1) {
			dx = point.x - arr[i - 1].x;
			dy = point.y - arr[i - 1].y;
		} else {
			dx = (arr[i + 1].x - arr[i - 1].x) / 2;
			dy = (arr[i + 1].y - arr[i - 1].y) / 2;
		}

		// Compute normal vector
		let normalX = -dy;
		let normalY = dx;

		// Normalize the normal vector
		let length = Math.sqrt(normalX ** 2 + normalY ** 2);
		if (length !== 0) {
			normalX /= length;
			normalY /= length;
		}

		// Apply offset
		return {
			x: point.x + normalX * offsetDistance,
			y: point.y + normalY * offsetDistance,
		};
	});
}

export function createArcDoorShape(doorWidth: number, outerHeight: number, centerHeight: number, frameWidth: number) {
	let shape = new THREE.Shape();

	const topArc = new THREE.Path()
		.moveTo(frameWidth, centerHeight)
		.quadraticCurveTo(doorWidth / 2, centerHeight, doorWidth - frameWidth, outerHeight);

	shape.add(topArc);
	const topArcPoints = topArc.getPoints(20);

	// Create the bottom arc using mirrored points (shifted in Y)
	const bottomArc = new THREE.Path();
	bottomArc.moveTo(topArcPoints[topArcPoints.length - 1].x, topArcPoints[topArcPoints.length - 1].y - frameWidth);

	[...topArcPoints].reverse().forEach((p, index) => {
		if (index !== 0) {
			bottomArc.lineTo(p.x, p.y - frameWidth);
		}
	});

	//tryout offset with angle
	const newBottomPath = (topPoints) => {
		let newPath = offsetPath(topPoints, -frameWidth);
		const bottomArc = new THREE.Path();
		bottomArc.moveTo(topPoints[topPoints.length - 1].x, topPoints[topPoints.length - 1].y - (frameWidth));
		// Reverse iterate over newPath to create the bottom arc
		[...newPath].reverse().forEach((p, index) => {
			if (index !== 0) {
				bottomArc.lineTo(p.x, p.y);
			}
		});
		return bottomArc;
	};
	//tryout offset with angle

	shape.add(newBottomPath(topArcPoints));

	shape.closePath();

	return shape;
}

export function createStraightDoorShape(
	doorWidth: number,
	outerHeight: number,
	centerHeight: number,
	frameWidth: number
) {
	let shape = new THREE.Shape();

	const topArc = new THREE.Path().moveTo(frameWidth, centerHeight).lineTo(doorWidth, outerHeight);

	shape.add(topArc);
	const topArcPoints = topArc.getPoints(20);

	// Create the bottom arc using mirrored points (shifted in Y)
	const bottomArc = new THREE.Path();
	bottomArc.moveTo(topArcPoints[topArcPoints.length - 1].x, topArcPoints[topArcPoints.length - 1].y - frameWidth);

	[...topArcPoints].reverse().forEach((p, index) => {
		if (index !== 0) {
			bottomArc.lineTo(p.x, p.y - frameWidth);
		}
	});

	shape.add(bottomArc);

	shape.closePath();

	return shape;
}

export function createWaveDoorShape(doorWidth: number, outerHeight: number, centerHeight: number, frameWidth: number) {
	let shape = new THREE.Shape();

	const topArc = new THREE.Path()
		.moveTo(frameWidth, centerHeight)
		.bezierCurveTo(
			doorWidth / 4,
			outerHeight + outerHeight / 4,
			doorWidth - doorWidth / 4,
			outerHeight / 2,
			frameWidth,
			outerHeight
		);

	shape.add(topArc);
	const topArcPoints = topArc.getPoints(20);

	// Create the bottom arc using mirrored points (shifted in Y)
	const bottomArc = new THREE.Path();
	bottomArc.moveTo(topArcPoints[topArcPoints.length - 1].x, topArcPoints[topArcPoints.length - 1].y - frameWidth);

	[...topArcPoints].reverse().forEach((p, index) => {
		if (index !== 0) {
			bottomArc.lineTo(p.x, p.y - frameWidth);
		}
	});

	shape.add(bottomArc);

	shape.closePath();

	return shape;
}
